// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__wJmZi","emails":"CreateEditClinics_emails__1E--X","emailTagLabel":"CreateEditClinics_emailTagLabel__2ZpbZ"};